module.exports = __webpack_public_path__ + "resources/img/img_alyac2_m_en.e075c192e48785851a49574a49ac31b0.png";